export default __webpack_public_path__ + "media/images/fancybox/fancy_shadow_e-015eb5ab0dc60d1299ec6182c73d73e1.png";